import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import IOptions from './IOptions';

/**
 * 获取用所有类型的未读消息数量
 */
class MessageCountUnread extends ApiBasic<IOptions, number> {

    public async api(option: IOptions): Promise<Response<number>> {

        const req: Request = new Request(CallType.GET, Urls.MESSAGE_COUNT_UNREAD, option);
        
        let data: Response<number> = await this.callAjax(req);
        
        if(!data.er){
            MyStore.instance.dispatch(reducers.system.ActionTypes.updateUnread, data.res);
        }

        return data;
    }
}

export default new MessageCountUnread().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/message/messageCountUnread/index.ts